/**
 * @hidden
 * Base class for image or video resources.
 */
export class Media {
    constructor(data, config) {
        this.config = config;
        Object.assign(this, data);
    }
    /**
     * Returns the hostname that should be used to load this media resource.
     * The hostname will use the staging and media host overrides if specified
     * otherwise it will use the defaultHost provided by the delivery API.
     * @param secure
     */
    getHost(secure) {
        if (this.config.stagingEnvironment) {
            return this.config.stagingEnvironment;
        }
        if (secure) {
            return this.config.secureMediaHost || this.defaultHost;
        }
        else {
            return (this.config.mediaHost || this.config.secureMediaHost || this.defaultHost);
        }
    }
    /**
     * Export media object to JSON
     */
    toJSON() {
        return {
            defaultHost: this.defaultHost,
            endpoint: this.endpoint,
            name: this.name,
            id: this.id
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTWVkaWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL21lZGlhL01lZGlhLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUdBOzs7R0FHRztBQUNILE1BQU0sT0FBZ0IsS0FBSztJQTJCekIsWUFBWSxJQUFTLEVBQVksTUFBMkI7UUFBM0IsV0FBTSxHQUFOLE1BQU0sQ0FBcUI7UUFDMUQsTUFBTSxDQUFDLE1BQU0sQ0FBQyxJQUFJLEVBQUUsSUFBSSxDQUFDLENBQUM7SUFDNUIsQ0FBQztJQUVEOzs7OztPQUtHO0lBQ0ksT0FBTyxDQUFDLE1BQWU7UUFDNUIsSUFBSSxJQUFJLENBQUMsTUFBTSxDQUFDLGtCQUFrQixFQUFFO1lBQ2xDLE9BQU8sSUFBSSxDQUFDLE1BQU0sQ0FBQyxrQkFBa0IsQ0FBQztTQUN2QztRQUVELElBQUksTUFBTSxFQUFFO1lBQ1YsT0FBTyxJQUFJLENBQUMsTUFBTSxDQUFDLGVBQWUsSUFBSSxJQUFJLENBQUMsV0FBVyxDQUFDO1NBQ3hEO2FBQU07WUFDTCxPQUFPLENBQ0wsSUFBSSxDQUFDLE1BQU0sQ0FBQyxTQUFTLElBQUksSUFBSSxDQUFDLE1BQU0sQ0FBQyxlQUFlLElBQUksSUFBSSxDQUFDLFdBQVcsQ0FDekUsQ0FBQztTQUNIO0lBQ0gsQ0FBQztJQUVEOztPQUVHO0lBQ0gsTUFBTTtRQUNKLE9BQU87WUFDTCxXQUFXLEVBQUUsSUFBSSxDQUFDLFdBQVc7WUFDN0IsUUFBUSxFQUFFLElBQUksQ0FBQyxRQUFRO1lBQ3ZCLElBQUksRUFBRSxJQUFJLENBQUMsSUFBSTtZQUNmLEVBQUUsRUFBRSxJQUFJLENBQUMsRUFBRTtTQUNaLENBQUM7SUFDSixDQUFDO0NBQ0YifQ==